import {
  api_verify_cloudflare_turnstile_token_path,
  api_verify_recaptcha_token_path,
} from '@routes';

import { SuccessResponse } from '../interfaces';
import request from './request';

export interface VerifyReCaptchaParams {
  recaptcha_token: string;
  recaptcha_action: string;
}

export interface VerifyCloudflareTurnstileParams {
  turnstile_token: string;
  turnstile_action: string;
}

export const verifyReCaptchaToken = async (
  params: VerifyReCaptchaParams
): Promise<SuccessResponse> => {
  const response = await request('post', api_verify_recaptcha_token_path(params));
  return response;
};

export interface VerifyCloudflareTurnstileResponse extends SuccessResponse {
  // One-time nonce for create-subscription / create-free-subscription (subscribe action only)
  turnstileNonce?: string;
}

export const verifyCloudflareTurnstileToken = async (
  params: VerifyCloudflareTurnstileParams
): Promise<VerifyCloudflareTurnstileResponse> => {
  const response = await request('post', api_verify_cloudflare_turnstile_token_path(params));
  return response;
};
